(function() {
  'use strict';
  angular.module('common')
  .directive('date', ['$filter', '$log', '$parse', 'cursorPosition', 'dateServices', function($filter,$log, $parse, cursorPosition,dateServices) {
    var allDigits = /\d+/g;
    var allButDigits = /\D+/g;
    var isADigit = /\d/;
    var supportedFormats = ["MM/DD/YYYY","MM/DD/YY","M/D/YYYY","M/D/YY","MM-DD-YYYY","MM-DD-YY","M-D-YYYY","M-D-YY"];
    var validSeperators = ["/","-"];
    var defaultPattern = dateServices.defaultDatePattern();
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function($scope, element, attrs, ngModelController) {
        var prevValue = '';
        var separator = "/";
        var minDate = $parse(attrs.minDate)($scope);
        var maxDate = $parse(attrs.maxDate)($scope);
        var getSeparatorIndices = function (val, aSeperator) {
          var allIndices = _.map(val,(v,i)=>{if (v===aSeperator){return i;}}).filter((i)=>{return i>0;});
          var indices = [];
          if (allIndices.length > 0) {
            indices[0] = allIndices[0] > 2 ? 2 : allIndices[0];
            indices[1] = (allIndices[1] && (allIndices[1] < indices[0] + 3) ) ? allIndices[1] : (indices[0] + 3);
          }else{
            indices = [2,5];
          }
          return indices;
        };
        var getSeperator = function(val){
          var userSeperator = val.replace(allDigits,'').substring(0,1);
          return (userSeperator && (_.find(validSeperators, (s) => {return s===userSeperator;}))) ? userSeperator : separator;
        };
        var isValidDateCharacter = function(dateChar){
            return isADigit.test(dateChar) || (_.find(validSeperators, (s) => {return s===dateChar;}));
        };
        moment.parseTwoDigitYear = dateServices.hookYYParser();
        ngModelController.$parsers.push(function(val) {
          if (!val) {
            return '';
          }
          var cursorPos = cursorPosition(element[0]);

          //If value is a number greater than 1, prefix number with 0
          if(val.length===1 && $.isNumeric(val) && val > 1){
            val = '0' + val;
            cursorPos+=1;
          }

          if (!isValidDateCharacter(val.charAt(cursorPos-1))) {
            val = val.replace(val.charAt(cursorPos-1),'');
          }
          var isDelete = (prevValue && val && val.length < prevValue.length);
          var currentSeperator = getSeperator(val);
          if (!isDelete) {
            var seperatorIndices = getSeparatorIndices(val, currentSeperator);
            val = val.replace(allButDigits,'');
            var viewValue = '';
            for (var index =0; (index < val.length && index < (seperatorIndices[1] + 3)); index++) {
              viewValue += val.charAt(index);
              if (_.find(seperatorIndices,(pos)=>{ return pos === viewValue.length;})) {
                viewValue += currentSeperator;
              }
            }
            val=viewValue;
            prevValue = val;
            ngModelController.$setViewValue(val);
            ngModelController.$render();
          }
          cursorPos = (!isDelete && val.charAt(cursorPos) === currentSeperator ? cursorPos + 1 : cursorPos);
          element[0].setSelectionRange(cursorPos,cursorPos);
          prevValue = val;
          return val;
        });
        ngModelController.$validators.validDate = function(val) {
          if (!val) {
            return true;
          }
          return (moment(val, supportedFormats, true).isValid() && moment(val,dateServices.dateFormat(val)).isValid() === true);
        };
        ngModelController.$validators.dateRange = function(val) {
          if (!(val && minDate && maxDate && moment(val, supportedFormats, true).isValid())) {
            return true;
          }
          var datePattern = dateServices.dateFormat(val);
          return (moment.max(moment(val,datePattern), moment(minDate,defaultPattern)).format() ===
                  moment.min(moment(val,datePattern), moment(maxDate,defaultPattern)).format());
        };
      }
    };
  }]).filter('teledentDate', ['$filter', 'dateServices', function($filter,dateServices) {
    return function(val) {
      if (val) {
        moment.parseTwoDigitYear = dateServices.hookYYParser();
        return $filter('date')(moment(val,dateServices.dateFormat(val)).toDate(),'yyyy-MM-dd');
      }
    };
  }]).filter('reverseTeledentDate', ['$filter', 'dateServices', function($filter, dateServices){
    return function(val) {
      if(val) {
        //Doing it this way to avoid any potential conflict with creating a Date and having TimeZone conflicts
        var splitDate = val.split("-");
        return splitDate[1] + "/" + splitDate[2] + "/" + splitDate[0];
      }
    };
  }]).factory('dateServices',['$log',function($log) {
    var dateRegex = /^(\d+)(\/)(\d+)(\/)(\d+)$/;
    var allButDigits = /\D+/g;
    var defaultPattern = 'MM/DD/YYYY';
    function hookYYParser() {
      function parseTwoDigitYear(input) {
        var cutOffYear = parseInt(moment().format('YY'));
        var inputYear  = parseInt(input);
        if (!isNaN(inputYear)) {
          return (inputYear > cutOffYear ? 1900 : 2000) + inputYear;
        }
      }
      return parseTwoDigitYear;
    }
    function defaultDatePattern() {
      return defaultPattern;
    }
    function dateFormat(val){
      var matches = val.replace(allButDigits,'/').match(dateRegex);
      return (matches[5].length === 2 ? 'MM/DD/YY' : defaultPattern);
    }
    return {
      hookYYParser: hookYYParser,
      defaultDatePattern: defaultDatePattern,
      dateFormat: dateFormat
    };
  }]);

})();
